import Image from "@/src/components/Image"

interface IconProps {
  className?: string
  isActive?: boolean
}

export function HomeIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-home.svg"
      alt="Home"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function BranchIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-branch.svg"
      alt="Branch"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function AccountsIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-accounts.svg"
      alt="Accounts"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function ConnectsIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-connects.svg"
      alt="Connects"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function ManageSlipsIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-manage-slips.svg"
      alt="Manage Slips"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function ManageAdminIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-manage-admin.svg"
      alt="Manage Admin"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function ApiConnectIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-api-connect.svg"
      alt="API Connect"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function HistoryIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-history.svg"
      alt="History"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function SettingsIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-settings.svg"
      alt="Settings"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function MoneyIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-money.svg"
      alt="Money"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}

export function TeamIcon({ className, isActive }: IconProps) {
  return (
    <Image
      src="/icons/icon-team.svg"
      alt="Team"
      width={20}
      height={20}
      className={className}
      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
    />
  )
}
